<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>The better part of valor is discretion.</i></p>
<p class="ded1">—William Shakespeare, <i>Henry IV, Part I</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?2db9cf6b